// СТАРАЯ МОДЕЛЬ, УДАЛИТЬ ПОТОМ!!!

import { addHours, subMinutes } from 'date-fns';
import Address from '@/models/list/address';
import Chats from '@/models/list/chats.js';
import { localeFormatDefault, serverDateDefault } from '@/plugins/date-print';
import { dateFnsFormat } from '@/helpers/dateFns';

// Модель активности этапа мероприятия
export default class StageActivities {
  constructor(activity) {
    this.addresses = (activity.addresses || []).map((address) => new Address(address));
    this.created_at = activity.created_at || '';
    this.description = activity.description || null;
    this.documents = activity.documents || [];
    this.event_stage_id = activity.event_stage_id;
    this.experts = activity.experts || [];
    this.id = activity.id;
    this.images = activity.images || [];
    this.is_online = activity.is_online || false;
    this.start_at = (activity.start_at && localeFormatDefault(activity.start_at)) || '';
    this.end_at = (activity.end_at && localeFormatDefault(activity.end_at)) || '';
    this.title = activity.title || null;
    this.event_stage = activity.event_stage || null;

    this.videos = activity.videos || [];
    this.chats = new Chats('activity', activity.id, activity.telegram || []);
    this.is_favorite = activity?.is_favorite || false;
  }

  get chat() {
    const [activeChat] = this.chats.list;
    return activeChat || null;
  }

  get isOnline() {
    return !this.addresses.length || this.is_online;
  }

  get address() {
    const [currentAddress] = this.addresses;
    return currentAddress || null;
  }

  get timePeriod() {
    const start = dateFnsFormat.readableTime(this.start_at);
    const end = dateFnsFormat.readableTime(this.end_at);
    return `${start}-${end}`;
  }

  get mskTimePeriod() {
    const serverStart = serverDateDefault(this.start_at);
    const serverEnd = serverDateDefault(this.end_at);
    const mskTimeOffset = 3; // hours;
    const start = dateFnsFormat.readableTime(addHours(new Date(serverStart), mskTimeOffset));
    const end = dateFnsFormat.readableTime(addHours(new Date(serverEnd), mskTimeOffset));
    return `${start}-${end}`;
  }

  /**
   *  date: Date;
   */
  checkIsActivityEndForDate(date) {
    const bufferDate = new Date(date);
    const currentDate = new Date();
    const endDate = new Date(this.end_at);

    bufferDate.setHours(endDate.getHours());
    bufferDate.setMinutes(endDate.getMinutes());
    bufferDate.setSeconds(endDate.getSeconds());
    bufferDate.setMilliseconds(endDate.getMilliseconds());

    if (bufferDate > endDate) {
      return true;
    }

    return currentDate > bufferDate;
  }

  checkIsActivityStartSoon(date) {
    const BEFORE_START_MINUTES = 10;

    const bufferDate = new Date(date);

    const currentDate = new Date();
    const startDate = new Date(this.start_at);

    bufferDate.setHours(startDate.getHours());
    bufferDate.setMinutes(startDate.getMinutes());
    bufferDate.setSeconds(startDate.getSeconds());
    bufferDate.setMilliseconds(startDate.getMilliseconds());

    const targetDate = subMinutes(startDate, BEFORE_START_MINUTES);

    return currentDate > targetDate;
  }

  checkIsVideoLinkVisible(date = new Date()) {
    return this.checkIsActivityStartSoon(date) && !this.checkIsActivityEndForDate(date);
  }
}
